const styles = () => ({
    alertContainer: {
        overflow: 'hidden',
        paddingBottom: '20px',
        '& h3': {
            fontWeight: 'bold',
            color: '#666',
            marginBottom: '5px',
        },
        '& p': {
            margin: '0',
        },
    },
    alertButtonContainer: {
        textAlign: 'center',
        marginTop: '20px',
    },
    alertButtonCta: {
        padding: '15px',
    },
    capitalize: {
        textTransform: 'capitalize',
    },
    centerProgress: {
        textAlign: 'center',
        margin: '30px 0 10px',
    },
});

export default styles;
